import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { useInstallationContext } from '../../context/installation';
import { useUserProfileStore } from '../../store/user-profile';

export const useUserPermissions = (installationId?: string) => {
  const userPermissions = useUserProfileStore((s) => s.permissions);
  const { selectedInstallationId } = useInstallationContext();

  const permissions: Record<string, boolean> = useMemo(() => {
    if (isEmpty(userPermissions)) return {};
    const id = installationId || selectedInstallationId || '';

    return id ? userPermissions[id] || {} : {};
  }, [selectedInstallationId, installationId, userPermissions]);

  return {
    permissions,
  };
};
